/* import __COLOCATED_TEMPLATE__ from './editor.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type App from 'embercom/app';
import type EcommerceProduct from 'embercom/models/ecommerce-product';

interface Args {
  activeContent: EcommerceProduct;
  defaultThemeColor: string;
}

export default class Editor extends Component<Args> {
  @service declare appService: AppService;

  get app(): App {
    return this.appService.app;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::EcommerceProduct::View::Editor': typeof Editor;
    'knowledge-hub/content-editor/ecommerce-product/view/editor': typeof Editor;
  }
}
